"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncTitleWithSlug = exports.slugifyDomain = exports.slugify = exports.removeSpaces = exports.passInputProps = exports.onEnter = exports.mapForSelect = exports.bindField = exports.bindChips = void 0;
var _map = _interopRequireDefault(require("lodash/map"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var slugify = exports.slugify = function slugify(slug) {
  return slug.toLowerCase().trim().replace(/["'/%<>~?+=,.():;[\]{}!@#$%^&*_]/g, '').replace(/[-\s]+/g, '-');
};
var slugifyDomain = exports.slugifyDomain = function slugifyDomain(name) {
  return name.replace(/[^a-zA-Z0-9]/g, '') // not a letter or number
  .toLowerCase();
};
var bindField = exports.bindField = function bindField(form, field) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? 'error' : _ref$error,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 'value' : _ref$value,
    _ref$checkbox = _ref.checkbox,
    checkbox = _ref$checkbox === void 0 ? false : _ref$checkbox,
    _ref$floatLabel = _ref.floatLabel,
    floatLabel = _ref$floatLabel === void 0 ? false : _ref$floatLabel,
    onChangeFn = _ref.onChangeFn,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? 'onChange' : _ref$onChange,
    onChangeReaction = _ref.onChangeReaction;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var props = _defineProperty(_defineProperty({
    name: form.$(field).name
  }, value, form.$(field).value || ''), error, form.$(field).error);
  if (checkbox) {
    props.checked = form.$(field).value;
    props[onChange] = function (event) {
      form.$(field).sync(null, event.target.checked);
      if (typeof onChangeReaction === 'function') {
        onChangeReaction(event);
      }
    };
  } else {
    props[onChange] = onChangeFn || function (event) {
      if (event && event.target) {
        form.$(field).sync(event.target.value);
        if (typeof onChangeReaction === 'function') {
          onChangeReaction(event);
        }
      }
    };
  }
  if (floatLabel && form.$(field).label) {
    props.floatingLabelText = form.$(field).label;
  }
  if (options.onlyIntegers) {
    var regex = /^[1-9]\d*$/g;
    var isInteger = props.value.toString().match(regex);
    if (!isInteger) {
      props.value = '1';
    }

    // Allow for clearing the number and then insert a new one
    if (props.error === 'The entityNumber field is required.') {
      props.value = '';
    }
  }
  return props;
};
var passInputProps = exports.passInputProps = function passInputProps(_ref2) {
  var placeholder = _ref2.placeholder,
    onKeyPress = _ref2.onKeyPress,
    error = _ref2.error,
    name = _ref2.name,
    value = _ref2.value,
    checked = _ref2.checked,
    onChange = _ref2.onChange;
  return {
    placeholder: placeholder,
    checked: checked,
    name: name,
    value: value,
    onKeyPress: onKeyPress,
    onChange: onChange,
    error: error
  };
};
var bindChips = exports.bindChips = function bindChips(form, field, _ref3) {
  var _ref3$placeholder = _ref3.placeholder,
    placeholder = _ref3$placeholder === void 0 ? 'placeholder' : _ref3$placeholder,
    _ref3$error = _ref3.error,
    error = _ref3$error === void 0 ? 'error' : _ref3$error,
    _ref3$floatLabel = _ref3.floatLabel,
    floatLabel = _ref3$floatLabel === void 0 ? false : _ref3$floatLabel;
  return _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    value: form.$(field).value
  }, placeholder, form.$(field).label), "onRequestAdd", function onRequestAdd(chip) {
    return form.$(field).sync([].concat(_toConsumableArray(form.$(field).value), [chip]));
  }), "onRequestDelete", function onRequestDelete(chip) {
    return form.$(field).sync(form.$(field).value.filter(function (e) {
      return e !== chip;
    }));
  }), error, form.$(field).error), floatLabel === true && {
    floatingLabelText: form.$(field).label
  });
};
var mapForSelect = exports.mapForSelect = function mapForSelect(collection, propMap) {
  return (0, _map["default"])(collection, function (item) {
    return {
      key: item[propMap.key],
      value: item[propMap.value],
      name: item[propMap.name]
    };
  });
};
var removeSpaces = exports.removeSpaces = function removeSpaces(e) {
  return {
    target: {
      value: e.target.value.replace(/ /g, '')
    }
  };
};
var syncTitleWithSlug = exports.syncTitleWithSlug = function syncTitleWithSlug(event, form) {
  var value = event.target.value;

  // We want to manipulate the input's value after the event handler
  // was processed. If we won't do that, the event handler may take
  // too much time, which sometimes prevents IE11 from catching
  // user input.

  window.setTimeout(function () {
    var field = form.$('slug');
    var newValue = slugify(value);
    if (newValue) {
      field.sync(newValue);
    } else {
      field.clear();
    }
  });
};
var onEnter = exports.onEnter = function onEnter(cb) {
  return {
    onKeyPress: function onKeyPress(e) {
      var key = e.key,
        value = e.target.value,
        shiftKey = e.shiftKey;
      if (key === 'Enter' && !shiftKey) {
        e.preventDefault();
        cb(value);
      }
    }
  };
};
//# sourceMappingURL=input-utils.js.map